import React from 'react';
//MUI Components
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import SelectInput from './../../common/SelectInput';
import MultiselectInputChipbox from '../../common/MultiselectInputChipbox';
//constants
import {
	maritalStatusOptions,
	motherTongueOptions,
	languageOptions,
	gotraOptions,
	kuldevataOptions,
	nakshatraOptions,
	casteOptions,
	rashiHindiOptions,
	mathOptions
} from './../../constants/profileData';
function SocialDetails({
	maritalStatus,
	motherTongue,
	caste,
	handleChange,
	data,
	languagesKnown,
	gotra,
	nakshatra,
	kuldevta,
	rashi,
	math,
}) {
	return (
		<div>
			<center>
				<h3 className='profile-header'>
					<Typography variant='h6' gutterBottom>
						Social Details
					</Typography>
				</h3>
			</center>
			<React.Fragment>
				<Grid container spacing={3}>
					{/* Marital Status */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='maritalStatus'
							label='Marital Status'
							value={maritalStatus}
							handleChange={handleChange}
							options={maritalStatusOptions}
						/>
					</Grid>
					{/* Mother Tongue */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='motherTongue'
							label='Mother Tongue'
							value={motherTongue}
							handleChange={handleChange}
							options={motherTongueOptions()}
						/>
					</Grid>
					{/* Caste */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='caste'
							label='Caste'
							value={caste}
							handleChange={handleChange}
							options={casteOptions}
						/>
					</Grid>
					{/* Gotra */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='gotra'
							label='Gotra'
							value={gotra}
							handleChange={handleChange}
							options={gotraOptions}
						/>
					</Grid>
					{/* Kuldevta */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='kuldevta'
							label='Kuldevta'
							value={kuldevta}
							handleChange={handleChange}
							options={kuldevataOptions}
						/>
					</Grid>
					{/* Nakshatra */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='nakshatra'
							label='Nakshatra'
							value={nakshatra}
							handleChange={handleChange}
							options={nakshatraOptions}
						/>
					</Grid>
					{/* Rashi */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='rashi'
							label='Rashi'
							value={rashi}
							handleChange={handleChange}
							options={rashiHindiOptions}
						/>
					</Grid>
					{/* Math */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='math'
							label='Math'
							value={math}
							handleChange={handleChange}
							error={data.math.error}
							helperText={data.math.error ? data.math.helperText : ""}
							options={mathOptions}
						/>
					</Grid>
					{/* Qualification  Test*/}
					<Grid
						item
						xs={12}
						sm={6}
						// className='createprofile-qualification'
					>
						<MultiselectInputChipbox
							name='languagesKnown'
							label='Languages Known'
							value={languagesKnown}
							onChange={handleChange}
							fullWidth
							variant='standard'
							placeholder='Select your Language'
							options={languageOptions}
						/>
					</Grid>
				</Grid>
			</React.Fragment>
		</div>
	);
}

export default SocialDetails;
